import { apiClient, safeApi, ApiResponse } from '../../utils/axiosWithAuth';
// Legacy functions for backward compatibility
import dummyUsers from './dummyUserData.json';

export interface UserProfile {
  uuid: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  profilePicture?: string;
  role: string;
  isActive: boolean;
}

export interface UpdateProfileDTO {
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
}

export interface UpdatePasswordDTO {
  currentPassword: string;
  newPassword: string;
}

export const getUserProfileAPI = () =>
  safeApi<UserProfile>(() =>
    apiClient.get<ApiResponse<UserProfile>>('/users/me')
  );

export const updateUserProfileAPI = (data: UpdateProfileDTO) =>
  safeApi<UserProfile>(() =>
    apiClient.put<ApiResponse<UserProfile>>('/users/profile', data)
  );

export const updatePasswordAPI = (data: UpdatePasswordDTO) =>
  safeApi<{ message: string }>(() =>
    apiClient.put<ApiResponse<{ message: string }>>('/users/password', data)
  );

export const uploadProfilePictureAPI = (file: File) => {
  const formData = new FormData();
  formData.append('profilePicture', file);
  
  return safeApi<{ profilePictureUrl: string; data: UserProfile }>(() =>
    apiClient.post<ApiResponse<{ profilePictureUrl: string; data: UserProfile }>>('/users/upload-profile-picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  );
};

// Define a type for our user data for type safety
export interface User {
  id: string;
  name: string;
  email: string;
}

// This function simulates fetching a single user by their ID
export const fetchUserById = (userId: string): Promise<{ data: User }> => {
  console.log(`Searching for user with ID: ${userId}`);

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const user = dummyUsers.find((user) => user.id === userId);
      if (user) {
        console.log("User found:", user);
        resolve({ data: user });
      } else {
        console.error(`User with ID ${userId} not found.`);
        reject(new Error(`User not found`));
      }
    }, 500); // 500ms delay to simulate a network request
  });
};